export const getImageUrl = (resource: string, id: string) => {
  return `https://cdn.parsly.com/images/${resource}/${id}.png`;
};

export const imageOnError = (e: any, defaultImagePath: string) => {
  if (e.target.src !== window.location.origin + defaultImagePath) {
    e.target.src = defaultImagePath;
  }
};
